module.exports = __webpack_public_path__ + "img/credit_lady.png";